import type { OrderDetails } from '@/entities/order/model'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

/**
 * Hook for navigating to order details from any order card component
 * Uses search params to show order details in a modal while keeping the parent route visible
 *
 * @returns A function that appends the orderId to the current URL
 */
export function useOrderDetailsNavigation() {
  const navigate = useNavigate()
  const location = useLocation()

  const navigateToOrderDetails = useCallback((orderId: OrderDetails['orderId'], additionalParams?: Record<string, string | boolean>) => {
    // Booleans travel as booleans: stringifying them first makes the router quote the
    // value, so the flag lands in the URL as `flag="true"` rather than `flag=true`.
    navigate({
      to: location.pathname,
      search: { orderId, ...additionalParams },
      resetScroll: false,
    })
  }, [navigate, location.pathname])

  return navigateToOrderDetails
}
